import { render } from "./ArtikelnummerTrustpilotStueckzahl.vue?vue&type=template&id=1c04448f&ts=true"
import script from "./ArtikelnummerTrustpilotStueckzahl.vue?vue&type=script&lang=ts"
export * from "./ArtikelnummerTrustpilotStueckzahl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__